import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import Actions_Wind_V2 from '~/Actions_Wind_V2';


import permission from '~/skills/permission';
import * as getStatus from '~/skills/getStatus';
import PageTitle from '~/components/PageTitle';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Input, EAA_Btn, EAA_ErrorText, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';
import Area from './Area';
import { getZoneData } from './Config/init_config';
const modeInfo = {
  add: {
    title: '每日進度新增',
  },
  edit: {
    title: '每日進度編輯',
  },
  view: {
    title: '每日進度檢視',
  },
};
const z_ary = ['z1', 'z2', 'z3', 'z4'];
const d_ary = ['today', 'recently'];

class Detail extends Component {
  constructor (props) {
    super(props);
    const { currentDate, PPDailyList = [] } = this.props;
    let preId = null;
    for (const o of PPDailyList) {
      if (moment(new Date(o.now_date)).format('YYYY-MM-DD') === moment(currentDate).subtract(1, 'days').format('YYYY-MM-DD')) {
        preId = o.id;
      }
    }
    this.state = { data: {}, old_data: {}, mode: '', canSend: true, errorAry: [], preId, fileUrlBoe: '', fileUrlMoea: '' };
  }

  componentDidMount () {
    const { id, currentDate, getPPDailyIdDetail, mode = '', setPageText, getBaseData, getPPDailyPreIdDetail } = this.props;
    const { preId } = this.state;
    setPageText(modeInfo[mode].title);

    Actions_Wind_V2.getSingleWindExcel({plan_id: id, type: 'moea', query_date: currentDate}).then(r => {
      if (r) {
        this.setState({ fileUrlMoea: r });
      }
    });
    Actions_Wind_V2.getSingleWindExcel({plan_id: id, type: 'boe', query_date: currentDate}).then(r => {
      if (r) {
        this.setState({ fileUrlBoe: r });
      }
    });


    if (mode !== 'add')getPPDailyIdDetail(id);
    getBaseData();
    if (preId)getPPDailyPreIdDetail(preId);
  }

  componentDidUpdate (preProps) {
    const { PPDailyIdDetail: prePPDailyIdDetail = {} } = preProps;
    const { PPDailyIdDetail = {}, mode } = this.props;
    if (Object.keys(prePPDailyIdDetail).length === 0 && Object.keys(PPDailyIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: PPDailyIdDetail, old_data: PPDailyIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('PPDailyIdDetail');
    clearKey('PPDailyPreIdDetail');
    clearKey('PageText');
  }

  _onClose=func => {
    this.props._onClose(func);
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  };

  getSendBodyV1=() => {
    const { currentDate } = this.props;
    const { data } = this.state;

    let body = {
      dock: data.dock || '',
      now_date: currentDate,
      sub1: data.sub1 || [],
      sub2: data.sub2 || [],
      sub3: data.sub3 || [],
      sub4: (data.sub4 || []).map((o, i) => ({ ...o, issue_order: i + 1 })),

      windcontract_id: Actions_Wind.wind_id(),
    };
    for (const o1 of z_ary) {
      let b1 = {
        [`${o1}_admin_analysis_date`]: data[`${o1}_admin_analysis_date`] || '',
        [`${o1}_admin_analysis_num`]: parseInt(data[`${o1}_admin_analysis_num`] || '0'),
        [`${o1}_admin_analysis_result`]: data[`${o1}_admin_analysis_result`] || '',
        [`${o1}_base_type`]: data[`${o1}_base_type`] || '',
        [`${o1}_have_do_allnum`]: parseInt(data[`${o1}_have_do_allnum`] || '0'),
        [`${o1}_industry_desc_method`]: data[`${o1}_industry_desc_method`] || '',
        [`${o1}_industry_desc_note`]: data[`${o1}_industry_desc_note`] || '',
        [`${o1}_industry_desc_reason`]: data[`${o1}_industry_desc_reason`] || '',
        [`${o1}_industry_desc_status`]: data[`${o1}_industry_desc_status`] || '',
        [`${o1}_issue_desc_status`]: data[`${o1}_issue_desc_status`] || '',
        [`${o1}_ship_name`]: data[`${o1}_ship_name`] || '',
        [`${o1}_ship_name_other`]: data[`${o1}_ship_name_other`] || '',
        [`${o1}_should_do_allnum`]: parseInt(data[`${o1}_should_do_allnum`] || '0'),
      };
      for (const o2 of d_ary) {
        const b2 = {
          [`${o1}_${o2}_option1_check`]: data[`${o1}_${o2}_option1_check`] || '',
          [`${o1}_${o2}_option1_child_check`]: data[`${o1}_${o2}_option1_child_check`] || '',
          [`${o1}_${o2}_option1_child_action`]: data[`${o1}_${o2}_option1_child_action`] || '',
          [`${o1}_${o2}_option2_check`]: data[`${o1}_${o2}_option2_check`] || '',
          [`${o1}_${o2}_option3_check`]: data[`${o1}_${o2}_option3_check`] || '',
          [`${o1}_${o2}_option4_check`]: data[`${o1}_${o2}_option4_check`] || '',
          [`${o1}_${o2}_option5_check`]: data[`${o1}_${o2}_option5_check`] || '',
          [`${o1}_${o2}_option5_note`]: data[`${o1}_${o2}_option5_note`] || '',
        };
        b1 = { ...b1, ...b2 };
      }
      body = { ...body, ...b1 };
    }
    return body;
  };

  getSendBody = () => {
    const { currentDate } = this.props;
    const { data } = this.state;

    let body = {
      dock: data.dock || '',
      now_date: currentDate,
      windcontract_id: Actions_Wind.wind_id(),
    };

    for (const zone of z_ary) {
      const zone_data = getZoneData(data, zone);
      body = { ...body, ...zone_data };
    }

    return body;
  };

  add=(status = {}) => {
    this.setState({ canSend: false });
    const { id, postAddNewPPDaily, putPPDailyIdDetailV2 } = this.props;
    const body = { data: { ...this.getSendBody(), ...status, id: id || '', is_delete: false } };
    console.log('add', body);
    // postAddNewPPDaily(body);
    putPPDailyIdDetailV2(body);
  }

  handleDownload = (type) => {
    const fileUrl = (type == 'boe')? this.state.fileUrlBoe : this.state.fileUrlMoea;

    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { id, putPPDailyIdDetailV2 } = this.props;
    const body = { data: { ...this.getSendBody(), ...status, id: id || '', is_delete: false } };
    console.log('update', body);
    putPPDailyIdDetailV2(body);
  }

  editYesterDay=() => {
    const { currentDate, _edit } = this.props;
    const { preId } = this.state;
    const date = moment(currentDate).subtract(1, 'days').format('YYYY-MM-DD');
    this._onClose(() => _edit(preId, date));
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.dock) === '', // 公文日期
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  errorBody=() => {
    const { data, mode } = this.state;
    const isCheck = mode === 'check';
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    let body = {};
    if (isCheck) {
      for (const o1 of z_ary) {
        const beChecking = returnInputValue(data[`${o1}_base_type`]) !== '';
        let b1 = {
          [`${o1}_base_type`]: returnInputValue(data[`${o1}_base_type`]) === '', // 項目
          [`${o1}_should_do_allnum`]: returnInputValue(data[`${o1}_should_do_allnum`]) === '', // 今日應完成
          [`${o1}_have_do_allnum`]: returnInputValue(data[`${o1}_have_do_allnum`]) === '', // 今日已完成
          //[`${o1}_ship_name`]: returnInputValue(data[`${o1}_ship_name`]) === '', // 工作船名 - 選項
          //[`${o1}_ship_name_other`]: (data[`${o1}_ship_name`] === '其他') && (returnInputValue(data[`${o1}_ship_name_other`]) === ''), // 工作船名 - 其他詳答
          //[`${o1}_industry_desc_status`]: returnInputValue(data[`${o1}_industry_desc_status`]) === '', // 業者說明 - 勾選
          //[`${o1}_issue_desc_status`]: returnInputValue(data[`${o1}_issue_desc_status`]) === '', // 議題說明 - 勾選
          //[`${o1}_admin_analysis_result`]: returnInputValue(data[`${o1}_admin_analysis_result`]) === '', // 分析說明 - 選項
        };
        for (const o2 of d_ary) {
          const b2 = {
            [`${o1}_${o2}_option5_note`]: (data[`${o1}_${o2}_option5_check`] === '1') && (returnInputValue(data[`${o1}_${o2}_option5_note`]) === ''), // 進度 - 已完成 - 自填
          };
          b1 = { ...b1, ...b2 };
        }
        if (beChecking) body = { ...body, ...b1 };
      }
    }
    return body;
  }

  returnA11Right=() => {
    const errorBody = this.errorBody();
    const { errorAry } = this.state;
    if (errorAry.indexOf(true) > -1) return false;
    let result = true;
    for (const key of Object.keys(errorBody)) {
      if (errorBody[key])result = false;
    }
    return result;
  }

  render () {
    const { mode = '', currentDate, PSPierList, id, exportPPDailyIdDetail, PPDailyPreIdDetail, canAdd, canEdit } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry, preId } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabledHandle = (mode === 'add' && !canAdd) || (mode === 'edit' && !canEdit);
    const disabled = isCheck || disabledHandle || (!getStatus.canEdit(data));
    
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;

    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    
    
    const errorBody = this.errorBody();
    const allRight = this.returnA11Right();
    const titleWidth = 100;
    const errorLeft = 20 + titleWidth;

    const areaProps = {
      titleWidth,
      disabled,
      returnInputValue,
      checkChange,
      changeData: this.changeData,
      data,
      errorBody,
      errorLeft,
      PPDailyPreIdDetail,
      editYesterDay: this.editYesterDay,
    };

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='港口' bol haveChange={checkChange('dock')} />
              <EAA_Select displayBorder disabled={disabled} list={PSPierList} value={returnInputValue(data.dock)} onChange={data => this.changeData({ label: 'dock', data })} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='日期' bol />
              <EAA_Input displayBorder disabled value={currentDate} />
            </EAA_ItemContainer>
          </EAA_Item>
        </EAA_Row>

        <Area {...areaProps} title='水下基礎PP/MP' z='z1' defaultOpen />
        <Area {...areaProps} title='水下基礎Jacket/TP' z='z2' />
        <Area {...areaProps} title='風力機' z='z3' />
        <Area {...areaProps} title='併網' z='z4' />

        {mode === 'edit' && (
          <EAA_Row>
            {
              this.state.fileUrlBoe &&
              <EAA_Btn backgroundColor='#5597B4' text='匯出日報_能源署版' onClick={() => this.handleDownload('boe')} />
            }
            {
              this.state.fileUrlMoea &&
              <EAA_Btn backgroundColor='#5597B4' text='匯出日報_經濟部版' onClick={() => this.handleDownload('moea')} style={{ marginLeft: 17 }} />
            }
          </EAA_Row>
        )}

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        {/* <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {!isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={() => this._onClose()} />}
          {!isCheck && <EAA_Btn text='確認' backgroundColor={disabledHandle ? 'gray' : rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} disabled={disabledHandle} />}
          {isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
        </div> */}

        <EAA_BottomBtn
          {...{
            data,
            mode: disabledHandle ? 'view' : mode,
            isCheck,
            allRight,
            canSend,
            onClose: () => this._onClose(),
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />

        <AddRes sucFunc={() => this._onClose()} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewPPDaily' />
        <EditRes sucFunc={() => this._onClose()} failFunc={() => this.setState({ canSend: true })} resKey='PutPPDailyIdDetailV2' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  PPDailyIdDetail: state.data.PPDailyIdDetail,
  PPDailyPreIdDetail: (state.data.PPDailyPreIdDetail || {}).list || [],
  PSPierList: state.data.PSPierList,
  PPDailyList: (state.data.PPDailyList || {}).list || [],
  ...permission.returnPermission(state),
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getBaseData: () => {
    Actions_Wind.getPSPierList(dispatch);
    Actions_Wind.getPPDailyBoatList(dispatch);
    Actions_Wind.getPPDailySeatList(dispatch);
  },
  getPPDailyIdDetail: id => Actions_Wind.getPPDailyIdDetail(dispatch, { id }),
  getPPDailyPreIdDetail: id => Actions_Wind.getPPDailyPreIdDetail(dispatch, { id }),
  postAddNewPPDaily: body => Actions_Wind.postAddNewPPDaily(dispatch, { body }),
  putPPDailyIdDetailV2: (body) => Actions_Wind.putPPDailyIdDetailV2(dispatch, { body }),
  exportPPDailyIdDetail: body => Actions_Wind.exportPPDailyIdDetail(body),
});

export default connect(mapStateToProps, mapDispatchToProps)(Detail);
